require('./mortgagePropertyValueAppraisalState.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const Immutable = require('immutable');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ components
const MortgageRequestFormattedAddress = require('components/mortgageRequest/mortgageRequestEstates/mortgageRequestEstatesData/mortgageRequestFormattedAddress/mortgageRequestFormattedAddress');
const MortgageRequestAnnexConstructions = require('components/mortgageRequest/mortgageRequestEstates/mortgageRequestEstatesData/mortgageRequestAnnexConstructions/mortgageRequestAnnexConstructions');
// @ actions
const estatesAction = require('actions/mortgageRequest/mortgageRequestInmuebles');
const documentActions = require('actions/mortgageRequest/mortgageRequestDocumentationCenter');
// @ constants
const { ESTATES_TYPE_ABBREVIATION } = require('constants/mortgageRequestEstates');
const { PLURAL_CHARACTER } = require('constants/index');
const documentConstants = require('constants/mortgageRequestDocumentsTypes');
const { DOCUMENTS_STATUS } = require('constants/mortgageRequestHolderData');

class MortgagePropertyValueAppraisalState extends React.Component {

    componentWillMount() {
        this.props.requestEstates(true);
    }

    buildActionButtons(appraisalTasCliUploadedByUser) {
        const { onHandleCancel, onSaveClick, immMortgageRequestPropertyValue, saveButtonDisabled } = this.props;
        const isLoading = immMortgageRequestPropertyValue.get('isFetching') || immMortgageRequestPropertyValue.get('isFetchingCert');

        return (
            <div className="mortgage-property-value-appraisal-state__action-buttons">
                <div className="mortgage-property-value-appraisal-state__go-back-button">
                    <OKButton
                        modifier="link-ghost"
                        onClick={onHandleCancel}
                    >
                        <FormattedText className="ok-link" value="mortgagePropertyValue-backText" />
                    </OKButton>
                </div>
                <div className="mortgage-property-value-appraisal-state__save-button">
                    <OKButton
                        onClick={onSaveClick}
                        loading={isLoading}
                        disabled={saveButtonDisabled || !appraisalTasCliUploadedByUser}
                    >
                        <FormattedText value="mortgagePropertyValue-save" />
                    </OKButton>
                </div>
            </div>
        );
    }

    buildAddressContent(immEstate) {
        return (
            <OKInformativeListItem
                title="mortgagePropertyValueAppraisalState-livingPlaceLabel"
                compact={true}
            >
                <MortgageRequestFormattedAddress
                    immEstate={immEstate}
                    className="mortgage-property-value-appraisal-state__text"
                />
            </OKInformativeListItem>
        );
    }

    buildAnnexConstructionsContent(immEstates) {
        const immAnnexConstructions = Immutable.fromJS(immEstates.get('list').reduce((annexContructions, immEstate) => {
            if (immEstate.get('propertyType') !== ESTATES_TYPE_ABBREVIATION.VIVIENDA) {
                annexContructions.push(immEstate);
            }

            return annexContructions;
        }, []));

        return <MortgageRequestAnnexConstructions immAnnexConstructions={immAnnexConstructions} />;
    }

    buildAppraisalCertContent() {
        return (
            <OKInformativeListItem
                title="mortgagePropertyValueAppraisalState-appraisalCertificateLabel"
                compact={false}
            >
                {this.props.dndTasCert}
            </OKInformativeListItem>
        );
    }

    buildAppraisalReportContent(appraisalReportStatus) {
        let statusText = '';

        switch (appraisalReportStatus) {
            case DOCUMENTS_STATUS.BORRADOR:
                statusText = formatText('mortgageRequestSimpleNote-pending');
                break;
            case DOCUMENTS_STATUS.PEND_VAL:
                statusText = formatText('mortgageRequestSimpleNote-pendingVal');
                break;
            case DOCUMENTS_STATUS.VERIFICADO:
                statusText = formatText('mortgageRequestSimpleNote-verified');
                break;
            case DOCUMENTS_STATUS.NO_VALIDO:
                statusText = formatText('mortgageRequestSimpleNote-invalid');
                break;
        }

        return (
            <OKInformativeListItem
                title="mortgagePropertyValueAppraisalState-appraisalReportLabel"
                compact={true}
            >
                <OKButton
                    leftIcon="icon-documento"
                    modifier="link-emphasize"
                    onClick={(evt) => this.handleOnDownloadFile(evt, documentConstants.TAS_CLI)}
                >
                    {formatText('mortgagePropertyValueDefined-labelResumeLink')}
                </OKButton>
                <span className="mortgage-property-value-appraisal-state__appraisal-cert-status">{statusText}</span>
            </OKInformativeListItem>
        );
    }

    buildContent(immEstates, appraisalTasCliUploadedByUser, appraisalReportStatus) {
        const immLivingPlace = immEstates.get('list').find(immEstate =>
            immEstate.get('propertyType') === ESTATES_TYPE_ABBREVIATION.VIVIENDA
        );

        let content;

        if (immLivingPlace) {
            const addressContent = this.buildAddressContent(immLivingPlace);
            const inlcludeContent = this.buildInlcudeContent(immLivingPlace);
            const appraisalReportContent = appraisalTasCliUploadedByUser ? this.buildAppraisalReportContent(appraisalReportStatus) : '';
            const appraisalCertContent = appraisalTasCliUploadedByUser ? this.buildAppraisalCertContent() : '';
            const columns = appraisalTasCliUploadedByUser ? 2 : 1;

            content = (
                <OKInformativeList columns={columns} title="mortgagePropertyValueAppraisalState-sectionTitle">
                    {addressContent}
                    {appraisalReportContent}
                    {inlcludeContent}
                    {appraisalCertContent}
                </OKInformativeList>
            );
        }

        return content;
    }

    buildGaragesContent(garages) {
        let garagesContent = '';

        if (garages > 0) {
            const pluralPostfix = garages !== 1 ? PLURAL_CHARACTER : '';
            garagesContent = formatText('mortgagePropertyValueAppraisalState-garages', [garages, pluralPostfix]);
        }

        return garagesContent;
    }

    buildInlcudeContent(immLivingPlace) {
        const storageRooms = parseInt(immLivingPlace.get('storageRooms'), 0);
        const garages = parseInt(immLivingPlace.get('garages'), 0);

        let title;

        if (storageRooms > 0 || garages > 0) {
            const storageRoomsContent = this.buildStorageRoomsContent(storageRooms);
            const garagesContent = this.buildGaragesContent(garages);

            let includeConnector = '';

            if (storageRooms > 0 && garages > 0) {
                includeConnector = formatText('mortgagePropertyValueAppraisalState-includeConnector');
            }

            title = formatText('mortgagePropertyValueAppraisalState-includeLabel', [storageRoomsContent, includeConnector, garagesContent]);
        }

        return <OKInformativeListItem title={title} />;
    }

    buildStorageRoomsContent(storageRooms) {
        let storageRoomsContent = '';

        if (storageRooms > 0) {
            const pluralPostfix = storageRooms !== 1 ? PLURAL_CHARACTER : '';
            storageRoomsContent = formatText('mortgagePropertyValueAppraisalState-storageRoom', [storageRooms, pluralPostfix]);
        }

        return storageRoomsContent;
    }

    handleOnDownloadFile(evt, type) {
        evt.preventDefault();

        this.props.requestDocument({
            documentType: type
        });
    }

    render() {
        const { immEstates, mortgageRequestSummaryDocumentation } = this.props;
        let content, annexConstructionsContent, actionButtons;
        let appraisalTasCliUploadedByUser = false;
        const appraisalRequestPendingState = formatText('mortgagePropertyValueAppraisalState-pending');
        let subtitle = formatText('mortgagePropertyValueAppraisalState-subtitle');
        const appraisal = mortgageRequestSummaryDocumentation.get('data').find(doc => doc.get('tipoDocumentoId') === documentConstants.TAS_CLI);
        const appraisalReportStatus = appraisal ? appraisal.get('estado') : DOCUMENTS_STATUS.NONE;

        if (appraisalReportStatus !== DOCUMENTS_STATUS.NONE && appraisalReportStatus !== DOCUMENTS_STATUS.PEND_APORTAR) {
            appraisalTasCliUploadedByUser = true;
        } else {
            subtitle = (
                <div>
                    <span>{formatText('mortgagePropertyValueAppraisalState-subtitle')}</span>:
                    <span className="mortgage-property-value-appraisal-state__subtitle-state">{appraisalRequestPendingState}</span>
                </div>
            );
        }

        if (immEstates.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            content = this.buildContent(immEstates, appraisalTasCliUploadedByUser, appraisalReportStatus);
            annexConstructionsContent = this.buildAnnexConstructionsContent(immEstates);
            actionButtons = this.buildActionButtons(appraisalTasCliUploadedByUser);
        }

        return (
            <div className="row no-outside-gutter mortgage-property-value-appraisal-state">
                <ContentBox>
                    <OKBoxTitle
                        value={formatText('mortgagePropertyValueAppraisalState-title')}
                        size="medium"
                    />
                    <span className="mortgage-property-value-appraisal-state__subtitle">
                        {subtitle}
                    </span>
                    {content}
                    {annexConstructionsContent}
                    {actionButtons}
                </ContentBox>
            </div>
        );
    }
}

MortgagePropertyValueAppraisalState.propTypes = {
    immEstates: PropTypes.object.isRequired,
    mortgageRequestSummaryDocumentation: PropTypes.object.isRequired,
    requestEstates: PropTypes.func.isRequired,
    dndTasCert: PropTypes.object.isRequired,
    saveButtonDisabled: PropTypes.bool.isRequired,
    onHandleCancel: PropTypes.func.isRequired,
    onSaveClick: PropTypes.func.isRequired,
    immMortgageRequestPropertyValue: PropTypes.object,
    requestDocument: PropTypes.func
};

module.exports.MortgagePropertyValueAppraisalState = connect(
    state => ({
        immEstates: state.mortgageRequestInmuebles,
        mortgageRequestSummaryDocumentation: state.mortgageRequestSummaryDocumentation,
        immMortgageRequestPropertyValue: state.mortgageRequestPropertyValue
    }),
    {
        requestEstates: estatesAction.requestInmuebles,
        requestDocument: documentActions.getDocument
    }
)(MortgagePropertyValueAppraisalState);
